import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ResetPasswordService} from "../reset-password/reset-password.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonsService} from "@core/service/commons.service";

@Component({
  selector: 'app-reset-password-page',
  templateUrl: './reset-password-page.component.html',
  styleUrls: ['../reset-password/reset-password.css']
})
export class ResetPasswordPageComponent implements OnInit {
  validateForm: FormGroup;
  constructor( private fb: FormBuilder,private resetPasswordService:ResetPasswordService,private activatedRoute:ActivatedRoute,private router:Router,private commonsService:CommonsService) { }
  public resetInfo:any = {};
  public passwordMinLength:number = 0;
  ngOnInit() {
    this.resetPasswordService.getPasswordLength().subscribe((data) => {
      this.passwordMinLength = data;
    });
    this.validateForm = this.fb.group({
      login:[null,[Validators.required]],
      password:[null,[Validators.required]],
      againPassword:[null,[Validators.required,ResetPasswordPageComponent.passwordEquar]]
    });
    this.activatedRoute.queryParams.subscribe(queryParams => {
      let resetKeyObj = {
        resetKey:queryParams.resetKey
      };
      this.resetPasswordService.resetCheck(resetKeyObj).subscribe((data) => {
        if(!data){
          this.router.navigateByUrl("/");
        }else{
          this.validateForm.patchValue({login:data.login});
          this.resetInfo.resetKey = queryParams.resetKey;
        }
      })
    });
  }

  static passwordEquar(control: FormControl) {
    if (!control || !control.parent) return null;
    if (control.value !== control.parent.get('password').value) {
      return { equar: true };
    }
    return null;
  }

  resetPassWord(){
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
    if(!this.validateForm.valid){
      return;
    }
    this.resetPasswordService.checkPassword(this.validateForm.value['password']).subscribe((data) => {
      if(data.status == 'success'){
        this.resetInfo.password = this.validateForm.value['password'];
        this.resetInfo.login = this.validateForm.value['login'];
        this.resetPasswordService.resetPassword(this.resetInfo).subscribe((data) => {
          this.router.navigateByUrl('/');
        });
      }else{
        this.commonsService.showWarningMessage(data.msg);
      }
    });

  }
}
